import Page from "../common/page/Page"
import style from "./Policies.module.css"

const TermsOfService = () => {
  return (
    <Page title="Terms of Service" searchDisabled={true}>
      <div className={style.policyContainer}>
        {/* Luxury Hero Banner */}
        <div className={style.heroHeader}>
          <h1>Terms of Service</h1>
          <p className={style.heroSubtitle}>
            Please review the terms governing your use of our website and services.
          </p>
        </div>

        {/* Content Card */}
        <div className={style.sectionCard}>
          <h2>Terms of Service</h2>

          <h3>Overview</h3>
          <p>
            This website is operated by Dr. Malu Mahendran’s. Throughout the site,
            the terms “we”, “us” and “our” refer to Dr. Malu Mahendran’s. By
            visiting our site and/or purchasing something from us, you agree to be
            bound by the following Terms of Service (“Terms”), including any
            additional terms and policies referenced herein.
          </p>

          <h3>1. Online Store Terms</h3>
          <p>
            By using this site, you confirm you are at least the age of majority
            in your jurisdiction. You may not use our products for any illegal or
            unauthorized purpose.
          </p>

          <h3>2. General Conditions</h3>
          <p>
            We reserve the right to refuse service to anyone. Your content may be
            transferred unencrypted, excluding credit card information which is
            always encrypted.
          </p>

          <h3>3. Accuracy, Completeness and Timeliness of Information</h3>
          <p>
            We are not responsible if information on this site is not accurate,
            complete, or current. You rely on it at your own risk.
          </p>

          <h3>4. Modifications to the Service and Prices</h3>
          <p>
            Product prices and service features may change at any time without
            notice. We are not liable for any modifications or discontinuations.
          </p>

          <h3>5. Products or Services</h3>
          <p>
            Some products may be exclusive to the website. We do our best to
            display product colors accurately but cannot guarantee your monitor’s
            display is accurate.
          </p>

          <h3>6. Accuracy of Billing and Account Information</h3>
          <p>
            We reserve the right to cancel or limit orders. You agree to provide
            current, accurate purchase and account information.
          </p>

          <h3>7. Optional Tools</h3>
          <p>
            We may provide access to third-party tools “as is” without warranties
            or endorsement. Use them at your own risk.
          </p>

          <h3>8. Third-Party Links</h3>
          <p>
            We are not responsible for content or services provided by third-party
            websites linked through this site.
          </p>

          <h3>9. User Comments, Feedback and Submissions</h3>
          <p>
            You grant us permission to use any comments or content you submit. We
            are not obligated to respond or compensate.
          </p>

          <h3>10. Personal Information</h3>
          <p>
            Your submission of personal information is governed by our{" "}
            <a href="/privacy-policy">Privacy Policy</a>.
          </p>

          <h3>11. Errors, Inaccuracies and Omissions</h3>
          <p>
            We reserve the right to correct any errors or inaccuracies without
            notice, including after an order has been placed.
          </p>

          <h3>12. Prohibited Uses</h3>
          <p>
            You may not use the site or its content for any unlawful, abusive, or
            prohibited purposes outlined in this section.
          </p>

          <h3>13. Disclaimer of Warranties; Limitation of Liability</h3>
          <p>
            We do not guarantee uninterrupted or error-free service. All products
            and services are provided “as is” and “as available.”
          </p>

          <h3>14. Indemnification</h3>
          <p>
            You agree to indemnify and hold harmless Dr. Malu Mahendran’s and
            affiliates from any claim or demand due to your breach of these Terms.
          </p>

          <h3>15. Severability</h3>
          <p>
            If any provision is found unenforceable, the remaining provisions will
            remain in effect.
          </p>

          <h3>16. Termination</h3>
          <p>
            These Terms remain effective until terminated by either party. We may
            terminate your use of the Service at any time for violations.
          </p>

          <h3>17. Entire Agreement</h3>
          <p>
            These Terms and any policies constitute the entire agreement between
            you and us.
          </p>

          <h3>18. Governing Law</h3>
          <p>
            These Terms shall be governed by and construed in accordance with the
            laws of India and the jurisdiction of Jaipur, Rajasthan.
          </p>

          <h3>19. Changes to Terms of Service</h3>
          <p>
            We may update these Terms at any time. Continued use of the website
            constitutes acceptance of changes.
          </p>

          <h3>20. Contact Information</h3>
          <p>
            Questions about the Terms of Service should be sent to{" "}
            <a href="mailto:drmmherbalsenquiry@gmail.com">
              drmmherbalsenquiry@gmail.com
            </a>
            .
          </p>
        </div>
      </div>
    </Page>
  )
}

export default TermsOfService
